/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Selectie wissen',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'Gegevens konden niet worden opgehaald',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'Klik om het opnieuw te proberen',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Laden...',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Meer tonen',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} van {totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': 'Geen overeenkomsten gevonden',
  'paginated-picker.async-select.select.option.error-message': 'Gegevens konden niet worden opgehaald',
  'paginated-picker.async-select.select.option.retry-message': 'Klik om het opnieuw te proberen',
  'paginated-picker.async-select.select.search-placeholder': 'Zoeken',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Volledige lijst weergeven'
};